export const getEntityId = (entity) => {
  if (entity == null) return null;
  if (typeof entity === "string" || typeof entity === "number") {
    return String(entity);
  }
  const id = entity._id ?? entity.id;
  return id != null ? String(id) : null;
};

export const idsEqual = (a, b) => {
  const idA = getEntityId(a);
  const idB = getEntityId(b);
  return idA != null && idB != null && idA === idB;
};

export const isCurrentUserMessage = (message, currentUser) =>
  idsEqual(message?.sender, currentUser);

export const formatConversationTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  if (isToday) {
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  }
  const weekAgo = new Date(now);
  weekAgo.setDate(weekAgo.getDate() - 7);
  if (date > weekAgo) {
    return date.toLocaleDateString("en-US", { weekday: "short" });
  }
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

export const formatSystemMessageDate = (value) => {
  if (!value) return "N/A";
  return new Date(value).toLocaleString();
};

export const getLatestSystemMessage = (systemMessages) =>
  systemMessages[0]?.systemMessage || null;

export const matchesConversationSearch = (conv, query) => {
  const name = `${conv.otherUser?.firstName || ""} ${conv.otherUser?.lastName || ""} ${conv.otherUser?.username || ""}`.toLowerCase();
  const preview = conv.lastMessage?.text?.toLowerCase() || "";
  const listing = conv.listing?.title?.toLowerCase() || "";
  return (
    name.includes(query) || preview.includes(query) || listing.includes(query)
  );
};

export const matchesSystemSearch = (systemMessages, query) => {
  if (query === "system") return true;
  return systemMessages.some((item) => {
    const subject = item.systemMessage?.subject?.toLowerCase() || "";
    const body = item.systemMessage?.body?.toLowerCase() || "";
    return subject.includes(query) || body.includes(query);
  });
};

export const PRIORITY_LABELS = {
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
};
